// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-white: #fff;
  --primary-black: #000;
  --primary-grey: #73739a;
  --primary-grey2: #f5f5f5;
  --primary-blue: #6d72f6;
  --primary-green: #08ce8a;
  --primary-black2: #1c1c57;
}

.Blog2-section {
  margin-top: -8.1rem;
  padding: 3rem 20px;
  /* position: relative;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(./Image/Blog\\ bg\\ 3.jpg); */
  background: rgb(128,132,255);
  background: radial-gradient(circle, rgba(128,132,255,0.8548012955182073) 0%, rgba(255,255,255,1) 100%);
}

.Blog2-container {
  width: 100%;
  margin: 0 auto;
  max-width: 1100px;
}


.Blog2-bg-content img{
    position: absolute;
    width: 100%;
    z-index: 1;
    pointer-events: none;
}

.Blog2-bg-content img:nth-child(1){
    bottom: 30px;
    right: 30px;
    max-width: 450px;
}

.Blog2-bg-content img:nth-child(2){
    top: 30%;
    left: 50%;
    max-width: 450px;
    transform: translate(-50%,-50%);
}

.Blog2-bg-content img:nth-child(3){
    bottom: 20%;
    left: 24%;
    max-width: 450px;
    transform: translate(-50%,-50%);
}

.Blog2-bg-content img:nth-child(4){
    top: 30px;
    right: 30px;
    max-width: 850px;
}

.Blog2-title-box {
  margin-bottom: 30px;
}

.Blog2-title-box h1 {
  font-size: 36px;
  color: var(--primary-black2);
}

.Blog2-card-container {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, 1fr);
}

.Blog2-card-content {
  z-index: 5;
  width: 100%;
  /* padding: 16px; */
  position: relative;
  border-radius: 12px;
  transition: 0.3s linear;
  background-color: #ffffffad;
  border: 1px solid #ffffff80;
}

.Blog2-card-content:hover {
  transform: translateY(-10px);
}

.Blog2-card-img-box {
  width: 100%;
  height: 200px;
  overflow: hidden;
  margin-bottom: 22px;
  border-radius: 12px 12px 0 0;
}

.Blog2-card-img-box img {
  width: 100%;
  height: 100%;
}

.Blog2-card-date-box{
  gap: 30px;
  display: flex;
  padding: 0 18px;
  margin-bottom: 10px;
  align-items: center;
  color: var(--primary-blue);
  justify-content: space-between;
}

.Blog2-card-date-box span{
  color: #444444;
}

.Blog2-card-title-box{
  padding: 0 18px 12px 18px; 
}

.Blog2-card-title-box h3 {
  font-size: 20px;
  margin-bottom: 6px;
  color: var(--primary-black);
}

.Blog2-card-title-box p {
  font-size: 16px;
  color: #444444;
  line-height: 22px;
  margin-bottom: 10px;
}

.Blog2-card-btn-box{
  display: flex;
  margin-top: 10px;
  align-items: center;
  margin-bottom: 10px;
  justify-content: flex-end;
}

.Blog2-card-btn-icon-box{
  width: 32px;
  height: 22px;
  padding: 4px;
  cursor: pointer;
  margin-bottom: -8px;
  border-radius: 5px;
  color: var(--primary-white);
  background-color: var(--primary-blue);
}


/* Responsive Breakpoints */
@media screen and (max-width: 1024px) {
    .Blog2-card-container {
      grid-template-columns: repeat(2, 1fr);
    }
  
    .Blog2-title-box h1 {
      font-size: 32px;
    }
  }
  
  @media screen and (max-width: 768px) {
    .Blog2-card-container {
      grid-template-columns: 1fr;
    }
  
    .Blog2-section {
      padding: 2rem 15px;
    }
  
    .Blog2-title-box h1 {
      font-size: 28px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Components/Blog2/Blog2.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB;;;;mDAIiD;EACjD,4BAA4B;EAC5B,sGAAsG;AACxG;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;AACvC;;;AAGA,2BAA2B;AAC3B;IACI;MACE,qCAAqC;IACvC;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":[":root {\n  --primary-white: #fff;\n  --primary-black: #000;\n  --primary-grey: #73739a;\n  --primary-grey2: #f5f5f5;\n  --primary-blue: #6d72f6;\n  --primary-green: #08ce8a;\n  --primary-black2: #1c1c57;\n}\n\n.Blog2-section {\n  margin-top: -8.1rem;\n  padding: 3rem 20px;\n  /* position: relative;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-image: url(./Image/Blog\\ bg\\ 3.jpg); */\n  background: rgb(128,132,255);\n  background: radial-gradient(circle, rgba(128,132,255,0.8548012955182073) 0%, rgba(255,255,255,1) 100%);\n}\n\n.Blog2-container {\n  width: 100%;\n  margin: 0 auto;\n  max-width: 1100px;\n}\n\n\n.Blog2-bg-content img{\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n    pointer-events: none;\n}\n\n.Blog2-bg-content img:nth-child(1){\n    bottom: 30px;\n    right: 30px;\n    max-width: 450px;\n}\n\n.Blog2-bg-content img:nth-child(2){\n    top: 30%;\n    left: 50%;\n    max-width: 450px;\n    transform: translate(-50%,-50%);\n}\n\n.Blog2-bg-content img:nth-child(3){\n    bottom: 20%;\n    left: 24%;\n    max-width: 450px;\n    transform: translate(-50%,-50%);\n}\n\n.Blog2-bg-content img:nth-child(4){\n    top: 30px;\n    right: 30px;\n    max-width: 850px;\n}\n\n.Blog2-title-box {\n  margin-bottom: 30px;\n}\n\n.Blog2-title-box h1 {\n  font-size: 36px;\n  color: var(--primary-black2);\n}\n\n.Blog2-card-container {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.Blog2-card-content {\n  z-index: 5;\n  width: 100%;\n  /* padding: 16px; */\n  position: relative;\n  border-radius: 12px;\n  transition: 0.3s linear;\n  background-color: #ffffffad;\n  border: 1px solid #ffffff80;\n}\n\n.Blog2-card-content:hover {\n  transform: translateY(-10px);\n}\n\n.Blog2-card-img-box {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n  margin-bottom: 22px;\n  border-radius: 12px 12px 0 0;\n}\n\n.Blog2-card-img-box img {\n  width: 100%;\n  height: 100%;\n}\n\n.Blog2-card-date-box{\n  gap: 30px;\n  display: flex;\n  padding: 0 18px;\n  margin-bottom: 10px;\n  align-items: center;\n  color: var(--primary-blue);\n  justify-content: space-between;\n}\n\n.Blog2-card-date-box span{\n  color: #444444;\n}\n\n.Blog2-card-title-box{\n  padding: 0 18px 12px 18px; \n}\n\n.Blog2-card-title-box h3 {\n  font-size: 20px;\n  margin-bottom: 6px;\n  color: var(--primary-black);\n}\n\n.Blog2-card-title-box p {\n  font-size: 16px;\n  color: #444444;\n  line-height: 22px;\n  margin-bottom: 10px;\n}\n\n.Blog2-card-btn-box{\n  display: flex;\n  margin-top: 10px;\n  align-items: center;\n  margin-bottom: 10px;\n  justify-content: flex-end;\n}\n\n.Blog2-card-btn-icon-box{\n  width: 32px;\n  height: 22px;\n  padding: 4px;\n  cursor: pointer;\n  margin-bottom: -8px;\n  border-radius: 5px;\n  color: var(--primary-white);\n  background-color: var(--primary-blue);\n}\n\n\n/* Responsive Breakpoints */\n@media screen and (max-width: 1024px) {\n    .Blog2-card-container {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  \n    .Blog2-title-box h1 {\n      font-size: 32px;\n    }\n  }\n  \n  @media screen and (max-width: 768px) {\n    .Blog2-card-container {\n      grid-template-columns: 1fr;\n    }\n  \n    .Blog2-section {\n      padding: 2rem 15px;\n    }\n  \n    .Blog2-title-box h1 {\n      font-size: 28px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
